import axios from "axios";
import { SystemLogService } from "./dtos/SystemLogService.schema.d";

export const getServices = async (): Promise<SystemLogService[]> => {
  const res = await axios.get<SystemLogService[]>("/admin/system-logs/services");
  return res.data;
};

export const getLogs = async (
  service: string,
  since: Date,
  until: Date
): Promise<string> => {
  const res = await axios.get<string>(`/admin/system-logs/${service}`, {
    params: {
      since: since.toISOString(),
      until: until.toISOString(),
    },
    responseType: "text",
  });

  return res.data;
};

export const downloadLogs = async (
  service: string,
  since: Date,
  until: Date
): Promise<void> => {
  const res = await axios.get(`/admin/system-logs/${service}/download`, {
    params: {
      since: since.toISOString(),
      until: until.toISOString(),
    },
    responseType: "blob",
  });

  const contentDisposition = res.headers["content-disposition"] ?? "";
  const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const fileName = fileNameMatch
    ? decodeURIComponent(fileNameMatch[1])
    : `${service}-logs.txt`;

  const url = URL.createObjectURL(new Blob([res.data], { type: "text/plain" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
